import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/onboarding/1')({
  component: lazyRouteComponent(() => import('./1.component'), 'Onboarding1Component'),
});
